import useAuth from './useAuth';

const useLOCevent = () => {
  const auth = useAuth();
  const event = auth.user?.event;

  return event;
};

export default useLOCevent;
